import * as RawKpiConstants from "../enums/RawKpiConstants";
import * as Bearer from "../converter/enums/BearerEnum";

export const COMMON = "GLOBAL";
export const BEGIN = "BEGIN";
export const END = "END";
export const RAW = "RAW";
import Logger from "../../../../../utils/Logger";

export default class KpiMapper {
    /**
     * Constructor
     *
     */
    constructor() {

    }

    /**
     * Map a key value if value is not null
     *
     * @param kpi
     * @param key
     * @param value
     */
    mapValue(kpi, key, value) {
        if (value !== null && value !== "undefined" && typeof value != "undefined") {
            if (typeof value.code != "undefined") {
                kpi[key] = value.code;
            } else {
                kpi[key] = value;
            }
        } else {
            Logger.log("Invalid kpi for key " + key + " / " + value);
        }
    }

    /**
     * Map common kpi part
     *
     * @param rawKpi
     * @param kpi
     */
    mapCommon(rawKpi, kpi) {
        kpi[COMMON] = {};

        this.mapValue(kpi[COMMON], "firmware", rawKpi[RawKpiConstants.HARDWARE_VERSION]);
        this.mapValue(kpi[COMMON], "iccid", rawKpi[RawKpiConstants.ICCID]);
        this.mapValue(kpi[COMMON], "imei", rawKpi[RawKpiConstants.IMEI]);
        this.mapValue(kpi[COMMON], "model", rawKpi[RawKpiConstants.MODEL]);
        this.mapValue(kpi[COMMON], "uid", rawKpi[RawKpiConstants.SERIAL_NUMBER]);
        this.mapValue(kpi[COMMON], "manufacturer", rawKpi[RawKpiConstants.BRAND]);
        this.mapValue(kpi[COMMON], "os_version", rawKpi[RawKpiConstants.SOFTWARE_VERSION]);

        this.mapValue(kpi[COMMON], "sim_imsi", rawKpi[RawKpiConstants.IMSI]);
        this.mapValue(kpi[COMMON], "sim_msisdn", rawKpi[RawKpiConstants.MSISDN]);
        this.mapValue(kpi[COMMON], "sim_state", rawKpi[RawKpiConstants.SIM_STATUS]);
        this.mapValue(kpi[COMMON], "private_ip", rawKpi[RawKpiConstants.LOCAL_IP]);
        this.mapValue(kpi[COMMON], "private_ip_protocol", rawKpi[RawKpiConstants.LOCAL_IP_PROTOCOL]);
        this.mapValue(kpi[COMMON], "public_ip", rawKpi[RawKpiConstants.WAN_IP]);
        this.mapValue(kpi[COMMON], "public_ip_protocol", rawKpi[RawKpiConstants.WAN_IP_PROTOCOL]);
        // TODO: Set those fields in specific proto fields - temporary fix
        this.mapValue(kpi[COMMON], "agt_custom_int_1", rawKpi[RawKpiConstants.WIFI_USERS]);
        this.mapValue(kpi[COMMON], "agt_custom_string_1", rawKpi[RawKpiConstants.HARDWARE_VERSION]);
        this.mapValue(kpi[COMMON], "agt_custom_string_2", rawKpi[RawKpiConstants.MODEL]);
    }

    /**
     * Map begin informations
     *
     * @param rawKpi
     * @param kpi
     */
    mapBegin(rawKpi, kpi) {
        kpi[BEGIN] = {};

        this.mapValue(kpi[BEGIN], "rad_bearer", rawKpi[RawKpiConstants.BEARER]);
        this.mapValue(kpi[BEGIN], "rad_ci", rawKpi[RawKpiConstants.CELL_ID]);
        this.mapValue(kpi[BEGIN], "lte_ci_start", rawKpi[RawKpiConstants.CELL_ID_4G]);
        this.mapValue(kpi[BEGIN], "rad_lac", rawKpi[RawKpiConstants.LAC]);
        this.mapValue(kpi[BEGIN], "rad_mcc", rawKpi[RawKpiConstants.MCC]);
        this.mapValue(kpi[BEGIN], "rad_mnc", rawKpi[RawKpiConstants.MNC]);
        this.mapValue(kpi[BEGIN], "rad_net_state", rawKpi[RawKpiConstants.NETSTAT]);
        this.mapValue(kpi[BEGIN], "pci_start", rawKpi[RawKpiConstants.PCI]);
        this.mapValue(kpi[BEGIN], "psc_start", rawKpi[RawKpiConstants.PSC]);
        this.mapValue(kpi[BEGIN], "rad_rssi", rawKpi[RawKpiConstants.RSCP]);
        if (rawKpi[RawKpiConstants.BEARER]) {
            switch(rawKpi[RawKpiConstants.BEARER].code) {
                case Bearer.GPRS.code:
                case Bearer.EDGE.code:
                case Bearer.GSM.code:
                case Bearer.GSM_RAT.code:
                case Bearer.TYPE_2G.code:
                    break;
                case Bearer.UMTS.code:
                case Bearer.CDMA.code:
                case Bearer.EVDO_0.code:
                case Bearer.EVDO_A.code:
                case Bearer.EVDO_B.code:
                case Bearer.C1XRTT.code:
                case Bearer.HSDPA.code:
                case Bearer.HSUPA.code:
                case Bearer.HSPA.code:
                case Bearer.IDEN.code:
                case Bearer.EHRPD.code:
                case Bearer.HSPAP.code:
                case Bearer.DUAL_CARRIER.code:
                case Bearer.TYPE_3G.code:
                    this.mapValue(kpi[BEGIN], "signal_quality_start", rawKpi[RawKpiConstants.ECNO]);
                    this.mapValue(kpi[BEGIN], "served_signal_start", rawKpi[RawKpiConstants.RSCP]);
                    break;
                case Bearer.LTE.code:
                case Bearer.TYPE_4G.code:
                case Bearer.LTE_A.code:
                    this.mapValue(kpi[BEGIN], "signal_quality_start", rawKpi[RawKpiConstants.RSRQ]);
                    this.mapValue(kpi[BEGIN], "served_signal_start", rawKpi[RawKpiConstants.RSRP]);
                    this.mapValue(kpi[BEGIN], "lte_bandwidth", rawKpi[RawKpiConstants.DL_BANDWIDTH]);
                    break;
            }
        }

        if (rawKpi[RawKpiConstants.RSSI]) {
            this.mapValue(kpi[BEGIN], "rad_rssi", rawKpi[RawKpiConstants.RSSI]);
        } else {
            this.mapValue(kpi[BEGIN], "rad_rssi", kpi[BEGIN]["served_signal_start"]);
        }

        this.mapValue(kpi[BEGIN], "snr_start", rawKpi[RawKpiConstants.SNR]);
        this.mapValue(kpi[BEGIN], "wifi_ssid", rawKpi[RawKpiConstants.WIFI_SSID]);
        this.mapValue(kpi[BEGIN], "wifi_state", rawKpi[RawKpiConstants.WIFI_STATUS]);
        this.mapValue(kpi[BEGIN], "earfcn", rawKpi[RawKpiConstants.EARFCN]);
        this.mapValue(kpi[BEGIN], "rad_band", rawKpi[RawKpiConstants.RAD_BAND]);
    }

    /**
     * Map end informations
     *
     * @param rawKpi
     * @param kpi
     */
    mapEnd(rawKpi, kpi) {
        kpi[END] = {};

        this.mapValue(kpi[END], "rad_bearer_end", rawKpi[RawKpiConstants.BEARER]);
        this.mapValue(kpi[END], "rad_ci_end", rawKpi[RawKpiConstants.CELL_ID]);
        this.mapValue(kpi[END], "lte_ci_end", rawKpi[RawKpiConstants.CELL_ID_4G]);
        this.mapValue(kpi[END], "signal_quality_end", rawKpi[RawKpiConstants.ECNO]);
        this.mapValue(kpi[END], "rad_lac_end", rawKpi[RawKpiConstants.LAC]);
        this.mapValue(kpi[END], "rad_mcc_end", rawKpi[RawKpiConstants.MCC]);
        this.mapValue(kpi[END], "rad_mnc_end", rawKpi[RawKpiConstants.MNC]);
        this.mapValue(kpi[END], "rad_net_state_end", rawKpi[RawKpiConstants.NETSTAT]);
        this.mapValue(kpi[END], "pci_end", rawKpi[RawKpiConstants.PCI]);
        this.mapValue(kpi[END], "psc_end", rawKpi[RawKpiConstants.PSC]);
        if (rawKpi[RawKpiConstants.BEARER]) {
            switch(rawKpi[RawKpiConstants.BEARER].code) {
                case Bearer.GPRS.code:
                case Bearer.EDGE.code:
                case Bearer.GSM.code:
                case Bearer.GSM_RAT.code:
                case Bearer.TYPE_2G.code:
                    break;
                case Bearer.UMTS.code:
                case Bearer.CDMA.code:
                case Bearer.EVDO_0.code:
                case Bearer.EVDO_A.code:
                case Bearer.EVDO_B.code:
                case Bearer.C1XRTT.code:
                case Bearer.HSDPA.code:
                case Bearer.HSUPA.code:
                case Bearer.HSPA.code:
                case Bearer.IDEN.code:
                case Bearer.EHRPD.code:
                case Bearer.HSPAP.code:
                case Bearer.DUAL_CARRIER.code:
                case Bearer.TYPE_3G.code:
                    this.mapValue(kpi[END], "signal_quality_end", rawKpi[RawKpiConstants.ECNO]);
                    this.mapValue(kpi[END], "served_signal_end", rawKpi[RawKpiConstants.RSCP]);
                    break;
                case Bearer.LTE.code:
                case Bearer.TYPE_4G.code:
                case Bearer.LTE_A.code:
                    this.mapValue(kpi[END], "signal_quality_end", rawKpi[RawKpiConstants.RSRQ]);
                    this.mapValue(kpi[END], "served_signal_end", rawKpi[RawKpiConstants.RSRP]);
                    this.mapValue(kpi[END], "lte_bandwidth_end", rawKpi[RawKpiConstants.DL_BANDWIDTH]);
                    break;
            }
        }

        if (rawKpi[RawKpiConstants.RSSI]) {
            this.mapValue(kpi[END], "rad_rssi_end", rawKpi[RawKpiConstants.RSSI]);
        } else {
            this.mapValue(kpi[END], "rad_rssi_end", kpi[END]["served_signal_end"]);
        }
        this.mapValue(kpi[END], "snr_end", rawKpi[RawKpiConstants.SNR]);
        this.mapValue(kpi[END], "wifi_ssid_end", rawKpi[RawKpiConstants.WIFI_SSID]);
        this.mapValue(kpi[END], "wifi_state_end", rawKpi[RawKpiConstants.WIFI_STATUS]);
        this.mapValue(kpi[END], "earfcn_end", rawKpi[RawKpiConstants.EARFCN]);
        this.mapValue(kpi[END], "rad_band_end", rawKpi[RawKpiConstants.RAD_BAND]);
    }

    /**
     * Do the mapping for protocol buffer from a raw kpi
     *
     * @param rawKpi
     * @returns {Promise}
     */
    map(rawKpi) {
        return new Promise((resolve) => {
            const kpi = {};
            kpi[RAW] = rawKpi;
            this.mapCommon(rawKpi, kpi);
            this.mapBegin(rawKpi, kpi);
            this.mapEnd(rawKpi, kpi);

            resolve(kpi);
        });
    }

}


/*

mapCommon(rawKpi, kpi) {
    kpi[COMMON] = {};

    this.mapValue(kpi[COMMON], "boot.os_build", rawKpi[RawKpiConstants.HARDWARE_VERSION]);
    this.mapValue(kpi[COMMON], "boot.iccid", rawKpi[RawKpiConstants.ICCID]);
    this.mapValue(kpi[COMMON], "boot.imei", rawKpi[RawKpiConstants.IMEI]);
    this.mapValue(kpi[COMMON], "boot.model", rawKpi[RawKpiConstants.MODEL]);
    this.mapValue(kpi[COMMON], "boot.uid", rawKpi[RawKpiConstants.SERIAL_NUMBER]);
    this.mapValue(kpi[COMMON], "boot.manufacturer", rawKpi[RawKpiConstants.BRAND]);
    this.mapValue(kpi[COMMON], "boot.os_version", rawKpi[RawKpiConstants.SOFTWARE_VERSION]);

    this.mapValue(kpi[COMMON], "sim.imsi", rawKpi[RawKpiConstants.IMSI]);
    this.mapValue(kpi[COMMON], "sim.msisdn", rawKpi[RawKpiConstants.MSISDN]);
    this.mapValue(kpi[COMMON], "sim.sim_state", rawKpi[RawKpiConstants.SIM_STATUS]);
    this.mapValue(kpi[COMMON], "ipAddress.private_ip", rawKpi[RawKpiConstants.LOCAL_IP]);
    this.mapValue(kpi[COMMON], "ipAddress.private_ip_protocol", rawKpi[RawKpiConstants.LOCAL_IP_PROTOCOL]);
    this.mapValue(kpi[COMMON], "ipAddress.public_ip", rawKpi[RawKpiConstants.WAN_IP]);
    this.mapValue(kpi[COMMON], "ipAddress.public_ip_protocol", rawKpi[RawKpiConstants.WAN_IP_PROTOCOL]);
}

mapBegin(rawKpi, kpi) {
    kpi[BEGIN] = {};

    this.mapValue(kpi[BEGIN], "radio_begin.rad_bearer", rawKpi[RawKpiConstants.BEARER]);
    this.mapValue(kpi[BEGIN], "radio_begin.rad_ci", rawKpi[RawKpiConstants.CELL_ID]);
    this.mapValue(kpi[BEGIN], "radio_begin.lte_ci_start", rawKpi[RawKpiConstants.CELL_ID_4G]);
    this.mapValue(kpi[BEGIN], "radio_begin.signal_quality_start", rawKpi[RawKpiConstants.ECNO]);
    this.mapValue(kpi[BEGIN], "radio_begin.rad_lac", rawKpi[RawKpiConstants.LAC]);
    this.mapValue(kpi[BEGIN], "radio_begin.rad_mcc", rawKpi[RawKpiConstants.MCC]);
    this.mapValue(kpi[BEGIN], "radio_begin.rad_mnc", rawKpi[RawKpiConstants.MNC]);
    this.mapValue(kpi[BEGIN], "radio_begin.rad_net_state", rawKpi[RawKpiConstants.NETSTAT]);
    this.mapValue(kpi[BEGIN], "radio_begin.pci_start", rawKpi[RawKpiConstants.PCI]);
    this.mapValue(kpi[BEGIN], "radio_begin.psc_start", rawKpi[RawKpiConstants.PSC]);
    this.mapValue(kpi[BEGIN], "radio_begin.served_signal_start", rawKpi[RawKpiConstants.RSCP]);
    this.mapValue(kpi[BEGIN], "radio_begin.rad_rssi", rawKpi[RawKpiConstants.RSCP]);
    this.mapValue(kpi[BEGIN], "radio_begin.served_signal_start", rawKpi[RawKpiConstants.RSRP]);
    this.mapValue(kpi[BEGIN], "radio_begin.signal_quality_start", rawKpi[RawKpiConstants.RSRQ]);
    this.mapValue(kpi[BEGIN], "radio_begin.rad_rssi", rawKpi[RawKpiConstants.RSSI]);
    switch(rawKpi[RawKpiConstants.BEARER]) {
        case Bearer.GPRS:
        case Bearer.EDGE:
        case Bearer.GSM:
        case Bearer.GSM_RAT:
        case Bearer.TYPE_2G:
            this.mapValue(kpi[BEGIN], "radio_begin.served_signal_start", rawKpi[RawKpiConstants.RSSI]);
            break;
    }
    this.mapValue(kpi[BEGIN], "radio_begin.snr_start", rawKpi[RawKpiConstants.SNR]);
    this.mapValue(kpi[BEGIN], "wifi_begin.wifi_ssid", rawKpi[RawKpiConstants.WIFI_SSID]);
    this.mapValue(kpi[BEGIN], "wifi_begin.wifi_state", rawKpi[RawKpiConstants.WIFI_STATUS]);
}

mapEnd(rawKpi, kpi) {
    kpi[END] = {};

    this.mapValue(kpi[END], "radio_end.rad_bearer", rawKpi[RawKpiConstants.BEARER]);
    this.mapValue(kpi[END], "radio_end.rad_ci", rawKpi[RawKpiConstants.CELL_ID]);
    this.mapValue(kpi[END], "radio_end.lte_ci_end", rawKpi[RawKpiConstants.CELL_ID_4G]);
    this.mapValue(kpi[END], "radio_end.signal_quality_end", rawKpi[RawKpiConstants.ECNO]);
    this.mapValue(kpi[END], "radio_end.rad_lac", rawKpi[RawKpiConstants.LAC]);
    this.mapValue(kpi[END], "radio_end.rad_mcc", rawKpi[RawKpiConstants.MCC]);
    this.mapValue(kpi[END], "radio_end.rad_mnc", rawKpi[RawKpiConstants.MNC]);
    this.mapValue(kpi[END], "radio_end.rad_net_state", rawKpi[RawKpiConstants.NETSTAT]);
    this.mapValue(kpi[END], "radio_end.pci_end", rawKpi[RawKpiConstants.PCI]);
    this.mapValue(kpi[END], "radio_end.psc_end", rawKpi[RawKpiConstants.PSC]);
    this.mapValue(kpi[END], "radio_end.served_signal_end", rawKpi[RawKpiConstants.RSCP]);
    this.mapValue(kpi[END], "radio_end.rad_rssi", rawKpi[RawKpiConstants.RSCP]);
    this.mapValue(kpi[END], "radio_end.served_signal_end", rawKpi[RawKpiConstants.RSRP]);
    this.mapValue(kpi[END], "radio_end.signal_quality_end", rawKpi[RawKpiConstants.RSRQ]);
    this.mapValue(kpi[END], "radio_end.rad_rssi", rawKpi[RawKpiConstants.RSSI]);
    switch(rawKpi[RawKpiConstants.BEARER]) {
        case Bearer.GPRS:
        case Bearer.EDGE:
        case Bearer.GSM:
        case Bearer.GSM_RAT:
        case Bearer.TYPE_2G:
            this.mapValue(kpi[END], "radio_end.served_signal_end", rawKpi[RawKpiConstants.RSSI]);
            break;
    }
    this.mapValue(kpi[END], "radio_end.snr_end", rawKpi[RawKpiConstants.SNR]);
    this.mapValue(kpi[END], "wifi_end.wifi_ssid", rawKpi[RawKpiConstants.WIFI_SSID]);
    this.mapValue(kpi[END], "wifi_end.wifi_state", rawKpi[RawKpiConstants.WIFI_STATUS]);
}

 */


// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/mapper/KpiMapper.js